import pages from '../../data/browser-pages.json';
import type { AppDef, AppContext } from '../../types/window';
import type { BrowserPage } from '../../types/content';
import { el } from './dom';

const catalog = pages as BrowserPage[];

function pageBy(id: unknown): BrowserPage {
  return catalog.find((p) => p.id === id) ?? catalog[0];
}

function paint(root: HTMLElement, ctx: AppContext): void {
  const page = pageBy(ctx.payload?.pageId);
  ctx.setTitle(page.title);
  const wrap = el('div', { className: 'app-stack' });
  const bar = el('div', { className: 'browser-bar' });
  bar.append(el('span', { text: 'Address' }), el('div', { className: 'browser-addr', text: page.address }));
  wrap.append(bar, el('h1', { text: page.title }));
  for (const p of page.paragraphs) wrap.append(el('p', { text: p }));
  root.replaceChildren(wrap);
}

export const browserApp: AppDef = {
  appId: 'browser',
  title: 'Explorer',
  icon: 'browser',
  defaultSize: { w: 480, h: 320 },
  singleton: true,
  mount(root, ctx) {
    paint(root, ctx);
    return () => root.replaceChildren();
  },
  update(root, ctx) {
    paint(root, ctx);
  },
};
